<template>
  <div class="box-father">
    <div style="height: 100%" v-if="!dialogTableVisible">
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">文化积淀管理&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>稿件列表</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="发布时间">
                  <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width: 400px !important"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="标题">
                  <el-input
                    v-model="form.title"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="专栏">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.columnName"
                  >
                    <el-option
                      v-for="item in columnNameList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <div style="display: flex;justify-content: end;margin-bottom: 10px;">
            <el-button @click="dutyWordExp" :loading="exportLoading" class="search">拉取</el-button>
          </div>
          <common-table
            :select="false"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :maxHeight="540"
          >
            <template v-slot:thumbnails="{ scope }">
              <img v-if="scope.row.thumbnails && JSON.parse(scope.row.thumbnails).length" :src="JSON.parse(scope.row.thumbnails)[0].thumbnailUrl" style="width: 98px;height: 48px;border-radius: 8px;">
              <img v-else src="@/assets/image/img/thumb.png" style="width: 98px;height: 48px;border-radius: 8px;"/>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                @click="qusetionDetail(scope.row)"
                style="font-size: 16px"
                type="text"
                >查看</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <detailForm
       style="height:100%"
      v-else
      :item="currentItem"
      @closeDialog="closeDetail"
    ></detailForm>
  </div>
</template>

<script>
import {
  updateAllStory,
  storyPageHt,
} from "@/api/task.js";
import commonTable from "@/components/table/index.vue";
import detailForm from "./detail.vue";
export default {
  components: {
    detailForm,
    commonTable
  },
  data() {
    return {
      loading: false,
      dialogTableVisible: false,
      currentItem: {},
      exportLoading: false,
      form: {
        columnName: "",
        channelName: "",
        title: "",
        publishTimeStart: '',
        publishTimeEnd: ''
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            slot: "thumbnails",
            label: "封面"
          },
          {
            prop: "title",
            label: "标题",
          },
          {
            prop: "columnName",
            label: "专栏"
          },
          {
            prop: "wgLikeCount",
            label: "点赞",
          },
          {
            prop: "wgDislikeCount",
            label: "点踩",
          },
          {
            prop: "wgCommentCount",
            label: "评论",
          },
          {
            prop: "publishTime",
            label: "发布时间",
            width: '200px'
          },
          {
            prop: "creator",
            label: "创建人",
          },
          {
            slot: "operation",
            label: "操作",
          }
        ]
      },
      columnNameList: [
        {
          value: '社区名片',
          text: "社区名片"
        },
        {
          value: '中关村印迹',
          text: "中关村印迹"
        },
        {
          value: '红色传承',
          text: "红色传承"
        },
      ],
      // 审核/详情
      dialogType: "",
      shanghuCount: [],
      date: []
    };
  },
  mounted() {
    this.getPointTypeListPageFun();
  },
  methods: {
    closeDetail () {
      this.dialogTableVisible = false;
      this.getPointTypeListPageFun();
    },
    // 查看详情
    qusetionDetail(row) {
      this.currentItem = row;
      this.dialogTableVisible = true;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.form.title = '';
      this.form.columnName = '';
      this.date = [];
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    // 拉取
    async dutyWordExp() {
      this.exportLoading = true;
      let res = await updateAllStory({
        publishTimeStart: '',
      });
      if (res.status == 200) {
        this.$message.success('拉取成功');
        setTimeout(() => {
          this.onSearch();
        }, 500);
      }
      this.exportLoading = false;
    },
    // 分页查询
    async getPointTypeListPageFun() {
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size,
        publishTimeStart: this.date && this.date.length ? this.date[0] : '',
        publishTimeEnd: this.date && this.date.length ? this.date[1] : '',
      };
      const res = await storyPageHt(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data ? (res.data.data.records
          ? res.data.data.records
          : []) : [];
        this.page.total = res.data ? res.data.data.total : 0;
      } else return this.$message.error(res.data.msg)
    },
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
.box-father {
  background: #F1F4F6 !important;
  overflow: hidden !important;
}
.postImg {
  width: 98px;
  height: 48px;
  border-radius: 8px;
}

.caogao {
  color: #0054FE;
  background: rgba(0, 84, 254, 0.0966);
  border-radius: 4px;
  padding: 2px 15px;
}

.yifabu {
  color: #00AC94;
  background: rgba(0, 172, 148, 0.0966);
  border-radius: 4px;
  padding: 2px 15px;
}

.yxj {
  color: #8C949C;
  background: rgba(140, 148, 156, 0.0966);
  border-radius: 4px;
  padding: 2px 15px;
}

.cl-primary {
  color: #008cff;
}
.mr-40 {
  margin-right: 40px;
}
.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}

.fileJson {
  img {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

/deep/ .el-carousel__arrow {
  width: 54px !important;
  height: 54px !important;
  font-size: 18px !important;
}
.pass {
  color: #17b3ad;
}
.noPass {
  color: #ff5348;
}
.warin {
  color: #FFA200;
}
</style>



// WEBPACK FOOTER //
// src/pages/culturalManage/index.vue